import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '@/lib/api';

export function AdminLoginPage() {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => api.adminLogin(username, password),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['admin-session'] });
      navigate('/admin/program');
    },
  });

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    mutation.mutate();
  }

  return (
    <section className="panel panel--login">
      <div className="panel__header">
        <span className="eyebrow">Admin</span>
        <h2>Programm & Teilnehmerinnen verwalten</h2>
        <p>Upload, Validierung, Publish und Kapazitätsüberblick für die Event-Orga.</p>
      </div>
      <form className="stack" onSubmit={handleSubmit}>
        <label className="field">
          <span>Benutzername</span>
          <input value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" />
        </label>
        <label className="field">
          <span>Passwort</span>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
          />
        </label>

        {mutation.error instanceof ApiError ? <p className="notice notice--error">{mutation.error.message}</p> : null}

        <button className="button" type="submit" disabled={mutation.isPending}>
          {mutation.isPending ? 'Login läuft…' : 'Admin öffnen'}
        </button>
      </form>
    </section>
  );
}
